<template>
    <div
        :class="{
            heroWide: true,
            'heroWide--dark': dark,
            'heroWide--borderBottom': borderBottom,
        }"
    >
        <v-layout row wrap>
            <v-flex xs12 md5 lg3 offset-lg1 class="heroWide__title">
                <h1>{{ header }}</h1>
                <p v-if="subline" class="header__subline">
                    {{ subline }}
                </p>
                <slot name="cta"></slot>
            </v-flex>

            <v-flex
                xs12
                md7
                lg7
                offset-lg1
                :class="{
                    heroWide__imageWrap: true,
                    'heroWide__imageWrap--borderLeft': !borderBottom,
                }"
            >
                <SVGIcon
                    v-if="disruptorSvg"
                    :icon-name="disruptorSvg"
                    class="heroWide__disruptorSvg"
                />
                <ResponsiveImage
                    :image-name="image"
                    :class="[
                        'heroWide__image',
                        { 'heroWide__image--reverse': reverseImg },
                    ]"
                />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import ResponsiveImage from '@/components/atoms/image/ResponsiveImage.vue'
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'

export default {
    name: 'HeroBannerWide',

    components: {
        ResponsiveImage,
        SVGIcon,
    },

    props: {
        header: {
            type: String,
            required: false,
            default: null,
        },

        subline: {
            type: String,
            required: false,
            default: null,
        },

        image: {
            type: String,
            required: false,
            default: null,
        },

        borderBottom: {
            type: Boolean,
            required: false,
            default: null,
        },

        reverseImg: {
            type: Boolean,
        },

        disruptorSvg: {
            type: String,
            required: false,
            default: null,
        },

        dark: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>

<style lang="stylus">
.heroWide {
    position: relative;
    text-align: center;

    @media $display-breakpoints.md-and-up {
        text-align: left;
    }

    &--dark {
        background-color: $cs-slate-400;
        color: $cs-white;
    }


    &--borderBottom {
        @media $display-breakpoints.md-and-up {
            border-bottom: 4px solid $cs-primary;
        }
    }

    .header__subline {
        margin: $cs-spaces.half 0 0;
    }

    &__title {
        order: 1;
        padding: $cs-space;
        position: relative;
        z-index: 1;

        @media $display-breakpoints.md-and-up {
            order: 0;
            padding: $cs-spaces.double;
        }

        @media $display-breakpoints.lg-and-up {
            padding: $cs-spaces.sextuple 0;
        }

        @media $display-breakpoints.xl-only {
            padding: $cs-spaces.s1000 0;
        }
    }

    &__imageWrap {
        position: relative;
        border-bottom: 4px solid $cs-primary;

        @media $display-breakpoints.md-and-up {
            border-bottom: 0;
        }

        &--borderLeft {
            @media $display-breakpoints.md-and-up {
                border-left: 4px solid $cs-primary;
            }
        }
    }

    &__image {
        display: block;
        height: 200px;
        object-fit: cover;
        width: 100%;

        @media $display-breakpoints.sm-and-up {
            flex: 0 0 auto;
            height: 300px;
        }

        @media $display-breakpoints.md-and-up {
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
            width: 100%;
        }

        &--reverse {
            transform: scaleX(-1);
        }
    }

    &__disruptorSvg {
        position: absolute;
        z-index: 2;
        right: 16px;
        height: 120px;
        width: 120px;
        bottom: -16px;

        @media $display-breakpoints.md-only {
            left: -56px;
            right: auto;
        }

        @media $display-breakpoints.lg-and-up {
            height: 156px;
            width: 156px;
            left: -56px;
            right: auto;
        }
    }
}
</style>
